export class VehicleConfigurationSearchCommandModel {
    public vehicleConfigurationCode: string;
    public vehicleConfigurationName: string;
    public statusCode: string;
}